import React, {type FC} from 'react'
import {LettersBox} from 'uikit'
import {useAppSelector} from 'store'
import {getLetters, getKeyboardView} from 'store/letter/selectors'
import {type PropsLettersBoxView} from './types'

const PREFIX = 'keyboard-'

export const KeyboardView: FC<PropsLettersBoxView> = ({onLetterClick}) => {
  const letters = useAppSelector(getLetters)
  const view = useAppSelector(getKeyboardView)

  return <LettersBox view={view} letters={letters} prefix={PREFIX} onLetterClick={onLetterClick} />
}
